const { Modal: ReactModal } = window.Edocat.Components;

class Modal extends React.PureComponent {
  onClose(event) {
    event && event.preventDefault();
  }

  render() {
    const { redirecting } = this.props;

    return (
      <ReactModal
        isOpen={redirecting}
        onModalClose={this.onClose}
        styles={{
          content: {
            width: 400,
            height: 100,
          },
        }}
      >
        <div className="Redirect-Modal">
          <div className="Redirect-Modal-Loader" />
          <p>{window.Edocat.texts['login.redirecting']}.</p>
        </div>
      </ReactModal>
    );
  }
}

const mapStateToProps = state => ({
  redirecting: state.login.redirecting,
});

export default reactRedux.connect(mapStateToProps, null)(Modal);
